import React, { useContext, useState } from 'react';

const BreadcrumbContext = React.createContext();

export function BreadcrumbProvider({ children }) {
  const [paths, setPaths] = useState([]);

  return (
    <BreadcrumbContext.Provider value={{ setPaths, paths }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export const useBreadcrumb = () => useContext(BreadcrumbContext);
